import React from 'react'
import { ReactComponent as VislineLogo } from 'assets/logos/logowithsubtext.svg'
import { ReactComponent as TruckAsset } from 'assets/logos/truck.svg'
import styles from 'components/Main/MainPage.module.css'
import { useTranslation } from 'react-i18next'

export function MainPage ({ messageToken }) {
  const { t } = useTranslation()

  return <div className={styles.mainContainer}>
    <div className={styles.logoContainer}>
      <VislineLogo className={styles.logoAsset}/>
    </div>
    <div className={styles.truckContainer}>
      <TruckAsset className={styles.truckAsset}/>
    </div>
    <h1>{t(messageToken)}</h1>
  </div>
}
